import { Component, For } from "solid-js";

export interface FilterChip {
  key: string;
  category: string;
  label: string;
}

export interface FilterChipsProps {
  chips: FilterChip[];
  onRemove: (key: string) => void;
  onClearAll: () => void;
}

export const FilterChips: Component<FilterChipsProps> = (props) => {
  return (
    <div
      class="flex flex-wrap items-center gap-2 mt-2"
      role="group"
      aria-label="Active filters"
    >
      <For each={props.chips}>
        {(chip) => (
          <span class="inline-flex items-center gap-1 h-6 px-1.5 font-mono text-2xs rounded-sm border border-line bg-surface text-ink-2">
            <span>
              {chip.category.toLowerCase()}: {chip.label}
            </span>
            <button
              type="button"
              class="hit-area inline-flex items-center justify-center w-3 h-3 leading-none cursor-pointer hover:text-ink transition-colors"
              onClick={() => props.onRemove(chip.key)}
              aria-label={`Remove ${chip.category}: ${chip.label} filter`}
            >
              <span aria-hidden="true">×</span>
            </button>
          </span>
        )}
      </For>
      <button
        type="button"
        class="h-7 px-2 -mx-2 rounded-sm focus-ring text-xs text-ink-3 hover:text-ink transition-colors cursor-pointer underline-offset-2 hover:underline"
        onClick={() => props.onClearAll()}
        aria-label="Clear all filters"
      >
        Clear all
      </button>
    </div>
  );
};
